const TypeDescription = {
    title: 'ROLES_DESCRIPTION',
    key: [],
    sections: [
        {
            columns: 1,
            fields: [
                {
                    label: 'PRODUCT_TYPES_TYPE_NAME',
                    key: ['name'],
                    isRequired: true,
                    pos: {
                        col: 1,
                        row: 1,
                        size: 1,
                    },
                },
                {
                    label: 'PRODUCT_TYPES_CATEGORY',
                    type: 'select',
                    key: ['category'],
                    isRequired: true,
                    options: [
                        { label: 'food', key: 'food' },
                        { label: 'beverage', key: 'beverage' },
                        { label: 'pet', key: 'pet' },
                    ],
                    pos: {
                        col: 1,
                        row: 2,
                        size: 1,
                    },
                },
            ],
        },
    ],
}

export { TypeDescription }
